import { useFavoriteWorkplacesFlag } from "@src/appV2/FeatureFlags/useFavoriteWorkplacesFlag";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { useWorkerGeoLocation } from "@src/appV2/Worker/useWorkerGeoLocation";

import { usePaginatedOpenShiftDates } from "../../Shift/Open/usePaginatedOpenShiftDates";
import { getShiftDiscoveryDefaultDateRange } from "../../utils/getShiftDiscoveryDefaultDateRange";

export function useFavoriteWorkplacesOpenShiftsCount() {
  const workerGeoLocation = useWorkerGeoLocation();
  const worker = useDefinedWorker();
  const { shiftDiscoveryWindowInDays } = useFavoriteWorkplacesFlag();

  const agentTimezone = worker.tmz ?? Intl.DateTimeFormat().resolvedOptions().timeZone;

  const { data, isLoading, status } = usePaginatedOpenShiftDates({
    filter: {
      area: {
        latitude: workerGeoLocation?.latitude ?? 0,
        longitude: workerGeoLocation?.longitude ?? 0,
        // This won't do anything because when we pass isFavoriteWorkplaceShift: true or "workplace.id" in the filter, the radius is ignored
        radiusInMiles: 150,
      },
      includeWindowedOutShifts: false,
      timezone: agentTimezone,
      isFavoriteWorkplaceShift: true,
    },
    initialDateRange: getShiftDiscoveryDefaultDateRange(shiftDiscoveryWindowInDays),
  });

  const favoriteWorkplacesOpenShiftsCount = Object.values(data?.pages[0]?.data ?? {}).reduce(
    (sum, openShift) => sum + openShift.total,
    0
  );

  return {
    isLoading,
    status,
    favoriteWorkplacesOpenShiftsCount,
    favoriteWorkplacesOpenShiftsCountByDate: data?.pages[0]?.data,
  };
}
